import React, {useContext, useState, useEffect} from "react"

import Button from "../../../../common/Button";
import {api} from "../../../../../api/api";
import InsertField from "../../../../common/InsertField";
import { getErrorByStatus, storeState} from "../../helpers";
import TranslationContext from "../../../../../context/TranslationContext";
import UserContext from "../../../../../context/UserContext";
import PhoneInsertField from "../../PhoneInput"

const MobileIdAction = ({setAccess, handlerBackBtn}) => {
    const {getTranslation} = useContext(TranslationContext)
    const {setApiWait} = useContext(UserContext)

    const [phone, setPhone] = useState("")
    const [authReqId, setAuthReqId] = useState("")

    const [progress, setProgress] = useState(100)
    const [pushDeliveryFail, setPushDeliveryFail] = useState(false)

    const [smsDeliverySuccess, setSmsDeliverySuccess] = useState(false)
    const [otp, setOtp] = useState("")

    const [error, setError] = useState("")
    const [errMessage, setErrorMsg]= useState("")

    useEffect(() => {
        if (error !== "") {
            if (getTranslation(error)!=="") {
                setErrorMsg(getTranslation(error))
            } else {setErrorMsg(error)}  
        }
    },[getTranslation, error])

    useEffect(() => {
        if (progress < 90 && progress) {
            startCheckConfirmPush()
            if (progress <= 1 && error === "") {
                setApiWait(false)
                setProgress(0)
                handlerBackBtn()
            }
        }
    }, [progress])

    const phoneChange = (evt) => {
        setPhone(v => {
            return evt.target.validity.valid
                ? evt.target.value
                : v
        })
    }

    const otpChange = (evt) => {
        setOtp(v => {
            return evt.target.validity.valid
                ? evt.target.value
                : v
        })
    }

    const checkOtpWithPhone = () => {
        if (otp === "") {
            setError('info_check')
        } else {
            setError("")
            setApiWait(true)

            api.getOtpChallenger(phone, otp).then(res => {
                if (res.status === 200 && res.data.status === "ok") {
                    setAccess(true)
                }
            }).catch(err => {
                if (err.response.status === 400) {
                    setError('err_check')
                    return
                }
                getErrorByStatus(err.response.status, setError, getTranslation)
            }).finally( () => {
                setApiWait(false)}
            )
        }
    }

    const sendSmsOtpRequest = () => {
        setApiWait(true)
        api.getOtpSMS(phone)
            .then(res => {
                setSmsDeliverySuccess(true)
                if (res.data.status === "success") {
                    setError("")
                    if (res.data.notify !== "") {
                        // console.log(res.data.notify)
                    }
                } else if (res.data.message === "not_expired") {
                    setError(getTranslation('info_reply_sms').split("[MIN]").join(`${res.data.timeout}`))

                    let notify = res.data.timeout
                    const notifyCount = setInterval(() => {
                        if (notify === 0 || notify < 0) {
                            setError("")
                            return () => clearInterval(notifyCount)
                        } else {
                            setError(getTranslation('info_reply_sms').split("[MIN]").join(`${notify}`))
                            notify--
                            return () => clearInterval(notifyCount)
                        }
                    }, 1000)
                }
        }).catch(err => {
            getErrorByStatus(err.response.status, setError, getTranslation)
        }).finally( () => {
            setApiWait(false)}
        )
    }
    
    const startCheckConfirmPush = () => {

        api.checkPushStatus(authReqId).then(res => {

            switch (res.data.status) {
                case "success":
                    // check user create
                    api.getCheckAuth().then(res => {
                        if (res.data.status === "ready" || res.data.status === "ok") {
                            setAccess(true)
                            setApiWait(false)
                        }
                    }).catch(err => {
                        getErrorByStatus(err.response.status, setError, getTranslation)
                        setApiWait(false)
                    })
                    break;
                case "failed": 
                    // отклонён запрос
                    getErrorByStatus(403, setError, getTranslation)
                    setProgress(0)
                    setApiWait(false)
                    break;
                case "waiting":
                    // ожидание подтверждения пуша 
                    break; 
                default:
                    setError("unknown response")
                    setProgress(0)
                    setApiWait(false)
                    break;
            }
        }).catch(err => {
            getErrorByStatus(err.response.status, setError, getTranslation)
            setProgress(0)
            setApiWait(false)
        })

    }

    const sendPushRequest = () => {
        const regexRu = /^[7-8]\d{10}$/
        // console.log(phone,regexRu.test(phone) )
        if (phone === "") {
            setError("no_num")
        } else if (!regexRu.test(phone)) {
            setError("Услуга доступна только на номерах российских операторов")
        } else {
            storeState("user_phone", phone)
            setApiWait(true);
            api.getPush(phone).then(res => {
                if (res.status === 200) {
                    setError("")
                    if (res.data.status === "success" || res.data.status === "retry") {
                        setAuthReqId(res.data.auth_req_id)
                        let timer = setInterval(() => {
                            if (error !== "") {
                                setProgress(0)
                                return () => clearInterval(timer)
                            }
                            setProgress((prevProgress) => {
                                return prevProgress <= 0 ? 0 : prevProgress - 1
                            })
            
                            return () => clearInterval(timer)
                        }, 1000)
                    }
                }
            }).catch(err => {
                if (err.response.status === 502) {
                    setPushDeliveryFail(true)
                    sendSmsOtpRequest()
                    return
                }
                getErrorByStatus(err.response.status, setError, getTranslation)
                setApiWait(false)
            })
        }
    }

    return (
        <>
            <span data-id_phrase="no_num">{getTranslation("no_num")}</span>
            <PhoneInsertField
                value={phone}
                phoneSetter={setPhone}
                turnOffStatus={!pushDeliveryFail && smsDeliverySuccess}
            />
            {(error !== "") && <p data-id_phrase={error}>{errMessage}</p>}
            {
                pushDeliveryFail && smsDeliverySuccess
                    ? <>
                        <p id="phone_info" className="main-font-style" data-id_phrase="info_succ_sms">
                            {getTranslation("info_succ_sms")}
                        </p>
                        <span style={{marginBottom: "1rem"}} data-id_phrase="sms_code_text">{getTranslation("sms_code_text")}</span>
                        <InsertField                    
                            type="password"
                            value={otp}
                            onChange={otpChange}
                            pattern='[0-9]*'
                        />
                        <Button onClick={checkOtpWithPhone} idPhrase="btn_acc"/>
                    </>
                    : <>
                        <Button idPhrase="btn_mob_id" onClick={sendPushRequest}/>
                    </>
            }
            <Button idPhrase="back" onClick={() => handlerBackBtn()}/>
        </>
    )
}

export default MobileIdAction